import { useQuery } from '@tanstack/react-query';

import { Settings } from 'src/features/administration/utils/types';
import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = '/config/settings/';

type QueryFnType = typeof queryFn;

const queryFn = (): Promise<Settings> => {
    return axios.get(formatResourcePath(RESOURCE));
};

interface UseQueryHookOptions {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(),
        ...config,
    });

export { useQueryHook as useGetSettings };
